"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationNav = exports.StyledPagination = exports.StyledPages = exports.StyledPageNumber = exports.StyledNavText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledPaginationNav = _styledComponents.default.button.withConfig({
  displayName: "Paginationstyle__StyledPaginationNav",
  componentId: "sc-gcsyhe-0"
})(["display:inline-flex;align-items:center;box-sizing:border-box;padding:8px 14px;position:relative;background:", ";border:1px solid ", ";color:", ";border-radius:16px;cursor:default;height:32px;:hover{color:", ";background:", ";border-color:", ";svg > path{fill:", ";}}:focus{outline:none;color:", ";border:1px solid ", ";background:", ";svg > path{fill:", ";}}:active{border:", ";background:", ";border:1px solid transparent;color:", ";svg > path{fill:", ";}}:first-child{margin-right:24px;}:last-child{margin-left:24px;}", ""], _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.cta.yellow, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey1, _shared.theme.palette.ui.neutral.grey1, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white, ({
  hide
}) => !hide && `
		visibility:hidden;
		opacity:0;
	`);

exports.StyledPaginationNav = StyledPaginationNav;

const StyledPagination = _styledComponents.default.div.withConfig({
  displayName: "Paginationstyle__StyledPagination",
  componentId: "sc-gcsyhe-1"
})(["display:flex;justify-content:center;align-items:center;font-size:", ";line-height:", ";letter-spacing:", ";user-select:none;"], _shared.theme.typography.h6.fontSize, _shared.theme.typography.h6.lineHeight, _shared.theme.typography.h6.letterSpacing);

exports.StyledPagination = StyledPagination;

const StyledPageNumber = _styledComponents.default.div.withConfig({
  displayName: "Paginationstyle__StyledPageNumber",
  componentId: "sc-gcsyhe-2"
})(["color:", ";padding:0 4px;a{", ";}"], _shared.theme.palette.brand.primary.gray, ({
  active
}) => active && `color:${_shared.theme.palette.brand.primary.charcoal} !important`);

exports.StyledPageNumber = StyledPageNumber;

const StyledNavText = _styledComponents.default.span.withConfig({
  displayName: "Paginationstyle__StyledNavText",
  componentId: "sc-gcsyhe-3"
})([":first-child{margin-right:5px;}:last-child{margin-left:5px;}"]);

exports.StyledNavText = StyledNavText;

const StyledPages = _styledComponents.default.div.withConfig({
  displayName: "Paginationstyle__StyledPages",
  componentId: "sc-gcsyhe-4"
})(["display:flex;"]);

exports.StyledPages = StyledPages;